import { TypeBadge, DurationPill } from "./atoms";
import styles from '../../../../styles/NavigationLogs.module.css';
import { GetNavigationLogsDto } from "./types";
interface LogsTableProps {
  logs: GetNavigationLogsDto[];
  onSelect: (log: GetNavigationLogsDto) => void;
}

export const LogsTable = ({ logs, onSelect }: LogsTableProps) => (
  <div className={styles.tableWrap}>
    <div className={styles.tableHeader}>
      <span className={styles.tableTitle}>Eventos</span>
      <span className={styles.logCount}>{logs.length} eventos</span>
    </div>

    <table className={styles.table}>
      <thead>
        <tr>
          <th style={{ width: 110 }}>Tipo</th>
          <th style={{ width: 130 }}>Ação</th>
          <th>Página</th>
          <th style={{ width: 190 }}>Utilizador</th>
          <th style={{ width: 95 }}>Duração</th>
          <th style={{ width: 110 }}>IP</th>
        </tr>
      </thead>
      <tbody>
        {logs.length === 0 ? (
          <tr>
            <td colSpan={6} className={styles.emptyCell}>
              Nenhum log encontrado
            </td>
          </tr>
        ) : (
          logs.map((log) => (
            <tr key={log.id} onClick={() => onSelect(log)} className={styles.tableRow}>
              <td><TypeBadge type={log.type} /></td>
              <td className={styles.muted}>{log.action}</td>
              <td className={styles.truncate}>{log.page}</td>
              <td className={styles.truncate}>
                {log.email ?? <span className={styles.muted}>anónimo</span>}
              </td>
              <td><DurationPill duration={log.duration} /></td>
              <td className={styles.mono}>{log.ip ?? "—"}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);
